goog.provide("shadow.js.shim.module$src$svg$artwork$cards_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$cards_svg");
shadow.js.shim.module$src$svg$artwork$cards_svg = shadow.js.nativeProvides["src/svg/artwork/cards.svg"] = shadow$bridge("src/svg/artwork/cards.svg");
module$shadow_js_shim_module$src$svg$artwork$cards_svg.default = shadow.js.shim.module$src$svg$artwork$cards_svg;
